import { Localization } from '@mui/material/locale';
import createTheme, { DashboardTheme } from './common';

export const createDarkTheme = (localization?: Localization): DashboardTheme =>
  createTheme('dark', localization);
